module.exports = __webpack_public_path__ + "img/91062.12be0905.svg";